import { render, staticRenderFns } from "./MadeComment.vue?vue&type=template&id=94fac3a2&scoped=true&"
import script from "./MadeComment.vue?vue&type=script&lang=js&"
export * from "./MadeComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fac3a2",
  null
  
)

export default component.exports